
import Vue from 'vue';
import _debounce from 'lodash/debounce';

export default Vue.extend({
	name: 'DebouncedInput',
	props: {
		value: {
			type: String,
			default: '',
		},
		debounceMs: {
			type: Number,
			default: 300,
		},
		immediateClear: {
			type: Boolean,
			default: true,
		},
		backgroundColor: {
			type: String,
			default: 'var(--grey-850)',
		},
	},
	data() {
		return {
			debouncedEmit: null as any,
		};
	},
	computed: {
		inputStyles() {
			return {
				'--input-bg-color': this.backgroundColor,
			};
		},
	},
	mounted() {
		this.debouncedEmit = _debounce((value: string) => {
			this.$emit('input', value || '');
		}, this.debounceMs);
	},
	methods: {
		onInput(value: string) {
			this.debouncedEmit(value);
		},
		onClear() {
			// Cancel any pending debounced calls and emit immediately for clear action
			if (this.debouncedEmit && this.debouncedEmit.cancel) {
				this.debouncedEmit.cancel();
			}
			if (this.immediateClear) {
				this.$emit('input', '');
			}
		},
		focus() {
			// Expose focus method for parent components
			const textField: any = this.$refs.textField;
			textField?.focus();
		},
	},
	beforeDestroy() {
		// Clean up debounced function on component destroy
		if (this.debouncedEmit && this.debouncedEmit.cancel) {
			this.debouncedEmit.cancel();
		}
	},
});
